var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import ReactDOM from 'react-dom';
import { parseQuery } from "./helpers";
export var __EDEN_SSR_DISABLED_IN_DEV__ = '__EDEN_SSR_DISABLED_IN_DEV__';
export function renderInBrowser(Page, cb, rootNodeId) {
    if (rootNodeId === void 0) { rootNodeId = 'root'; }
    return __awaiter(this, void 0, void 0, function () {
        var renderInitialPropsNode, url, pathname, query, context, initialRenderProps, decodedPreloadData, preloadData, err_1, err_2, page;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    renderInitialPropsNode = document.getElementById('RENDER_DATA');
                    url = window.location.href;
                    pathname = window.location.pathname;
                    query = parseQuery(url);
                    context = {
                        pathname: pathname,
                        query: query,
                    };
                    if (renderInitialPropsNode) {
                        try {
                            decodedPreloadData = decodeURIComponent(renderInitialPropsNode.innerText);
                            preloadData = JSON.parse(decodedPreloadData);
                            if (!preloadData._EDEN_NO_PRELOAD_DATA_) {
                                initialRenderProps = preloadData;
                            }
                        }
                        catch (err) {
                            if (process.env.NODE_ENV !== 'production') {
                                console.error(err);
                            }
                        }
                    }
                    if (!(process.env.NODE_ENV !== 'production' && typeof Page.getInitialProps === 'function')) return [3 /*break*/, 4];
                    console.warn('Duplicate calling `getInitialProps` for hot reload of `initialProps` changes in development mode. ' +
                        "`getInitialProps` won't be called twice in production mode.");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Page.getInitialProps(context)];
                case 2:
                    initialRenderProps = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [3 /*break*/, 4];
                case 4:
                    if (!(process.env.NODE_ENV === 'production' &&
                        typeof Page.getInitialProps === 'function' &&
                        typeof initialRenderProps === 'undefined')) return [3 /*break*/, 8];
                    _a.label = 5;
                case 5:
                    _a.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, Page.getInitialProps(context)];
                case 6:
                    initialRenderProps = _a.sent();
                    return [3 /*break*/, 8];
                case 7:
                    err_2 = _a.sent();
                    return [3 /*break*/, 8];
                case 8:
                    page = React.createElement(Page, initialRenderProps !== null && initialRenderProps !== void 0 ? initialRenderProps : {});
                    if (window[__EDEN_SSR_DISABLED_IN_DEV__]) {
                        console.warn('SSR has been disabled in development mode. You can turn it off by setting `disableSSRInDev` false.');
                        ReactDOM.render(page, document.getElementById(rootNodeId), cb);
                    }
                    else {
                        ReactDOM.hydrate(page, document.getElementById(rootNodeId), cb);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * You should only import this function from `@ies/eden-ssr-react/render`, import it from `@ies/eden-ssr-react`
 * will lead to unexpected errors. The render function will mount page when page is loaded in browser,
 * it will only be called in browser.
 *
 * @public
 * @remarks
 * This function takes only one argument `Page`, which has the type of {@link EdenPage | EdenPage}, note that
 * `Page` is not a React element, but a React component, it's different from `ReactDOM.render`.
 *
 * @param Page - `Page` is a React component with optional static methods {@link GetInitialProps} or
 * {@link GetDerivedHeadElement}, this extended React component is defined with type {@link EdenPage}.
 * @param cb - `cb` is a callback function that will be passed to `React.hydrate` as the third argument.
 */
export function render(Page, cb, rootNodeId) {
    if (rootNodeId === void 0) { rootNodeId = 'root'; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof window !== 'undefined')) return [3 /*break*/, 2];
                    return [4 /*yield*/, renderInBrowser(Page, cb, rootNodeId)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
